import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { KeyFeature } from "@/components/Product/Feature/KeyFeatures/keyFeatures.types";

type KeyFeaturesContextValue = {
    keyFeatures: Array<KeyFeature>;
};

type KeyFeaturesContextProviderProps = {
    keyFeatures: Array<KeyFeature>;
    children: ReactNode;
};

export const KeyFeaturesContext = createContext<
    KeyFeaturesContextValue | undefined
>(undefined);
KeyFeaturesContext.displayName = "KeyFeaturesContext";

export const KeyFeaturesContextProvider = ({
    keyFeatures,
    children
}: KeyFeaturesContextProviderProps) => {
    return (
        <KeyFeaturesContext.Provider value={{ keyFeatures: keyFeatures }}>
            {children}
        </KeyFeaturesContext.Provider>
    );
};

export const useKeyFeaturesContext = () => {
    const context = use<KeyFeaturesContextValue | undefined>(
        KeyFeaturesContext
    );

    if (!isDefined(context)) {
        throw new Error(`${KeyFeaturesContext.displayName} is undefined.`);
    }

    return context;
};
